import { QueryClientProvider } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { createAppQueryClient } from '@/lib/queryClient'

const queryClient = createAppQueryClient()

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  )
}
